import React, { useState, useRef } from 'react';
import { Camera } from 'lucide-react';

const PropertyPhoto: React.FC = () => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImageUrl(event.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="w-full max-w-md">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="hidden"
      />
      <div
        onClick={handleClick}
        className={`
          relative w-full h-48 rounded-lg border-2 border-dashed border-gray-300 
          hover:border-gray-400 cursor-pointer transition-colors
          ${imageUrl ? '' : 'bg-gray-50'}
        `}
        style={
          imageUrl
            ? {
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                border: 'none',
              }
            : {}
        }
      >
        {!imageUrl && (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-400">
            <Camera size={48} />
            <p className="mt-2 text-sm">Foto hinzufügen</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyPhoto;